import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { AppDispatch, useDispatch, useSelector } from '@common/oneclub/store'
import * as Types from './type'
import { queryDictionary, queryEfficientProvider, queryProviderDictionary } from '@common/oneclub/services/api/dictionary'
import { GroupKeyType } from '@common/oneclub/services/api/dictionary/type'
import { useMount } from 'ahooks'

const initialState: Types.InitialStateType = {
  dictionary: {},
  providerDic: {},
  providerList: [],
}

const dictionarySlice = createSlice({
  name: 'dictionary',
  initialState: initialState,
  reducers: {
    setDictionary(state, action: PayloadAction<Types.InitialStateType['dictionary']>) {
      const dictionary = state.dictionary
      return {
        ...state,
        dictionary: {
          ...dictionary,
          ...action.payload,
        },
      }
    },
    setProviderDic(state, action: PayloadAction<Types.InitialStateType['providerDic']>) {
      return {
        ...state,
        providerDic: action.payload,
      }
    },
    setProviderList(state, action: PayloadAction<Types.InitialStateType['providerList']>) {
      return {
        ...state,
        providerList: action.payload,
      }
    },
  },
})

/** 获取字典配置 */
export const fetcDictionary = (group: GroupKeyType) => async (dispatch: AppDispatch) => {
  const { dictionaryInfos } = await queryDictionary({ group })
  dispatch(
    setDictionary({
      [group]: dictionaryInfos,
    })
  )
}
export const { setDictionary, setProviderDic, setProviderList } = dictionarySlice.actions
export default dictionarySlice.reducer

/** 查询服务商配置 */
export const queryProviderConfigList = () => async (dispatch: AppDispatch) => {
  const res = await queryProviderDictionary()
  const { data } = res
  const { providerLogoRespVos } = data || {}
  if (providerLogoRespVos?.length) {
    const companyList = providerLogoRespVos.map(({ providerCode, logoUrl, providerName }) => ({
      name: providerCode,
      url: logoUrl,
      label: providerName,
    }))
    const formatCompanyList = companyList.reduce((obj, item) => {
      const key = item.name
      if (key) obj[key] = item
      return obj
    }, {})
    dispatch(setProviderDic(formatCompanyList))
    return formatCompanyList
  }
}

/** 查询ONESHIP发货地区支持的全部物流服务商 */
export const queryFullProviderConfigList = () => async (dispatch: AppDispatch) => {
  const res = await queryEfficientProvider()
  const { data } = res
  const { providerLogoRespVos } = data || {}
  if (providerLogoRespVos?.length) {
    dispatch(setProviderList(providerLogoRespVos))
    return providerLogoRespVos
  }
}

/**
 * 使用服务商配置
 * @returns
 */
export function useProviderDic() {
  const dispatch = useDispatch()
  useMount(() => {
    dispatch(queryProviderConfigList())
  })
  return useSelector((state) => state.dictionarySlice.providerDic)
}
